export default "__VITE_ASSET__DIN6Cg1Q__"